import { hasCustomContentMenuItem, hasTrackingLicense } from 'ff/common/system';
import {
    renderAircraft,
    renderAirportDirectory,
    renderCustomContent,
    renderDispatch,
    renderDocs,
    renderFleetTracking,
    renderOrg,
} from '../MenuItems';
import fillSpace from '../MenuItems/FillSpace';
import { RenderMenuParams } from 'ff/common/components/FFMenuV2/RenderMenuParams';

export default function RenderFspMenu({
    currentUser,
    fspUser,
}: RenderMenuParams) {
    const {
        dispatch_tools,
        isOrgUserAdmin,
        isOrgAircraftAdmin,
        isOrgFlightsAdmin,
        isFspAdmin,
        isFspFlightManager,
        isOrgDocumentsAdmin,
        isFF_FspAdmin,
        hasDispatchLowca,
    } = currentUser;

    const toReturn = [];

    /*
    If the user has fsp_tier2 AND dispatch_tools, they should see dispatch
    If the user has fsp_tier2 and does NOT have dispatch_tools, they should NOT see dispatch
    Basically, if the user has fsp_tier2, all rules are out the window. The only rule that matters is does the
    fspUser have dispatch_tools or not.
    */
    if (
        (fspUser?.fsp_tier2 && fspUser?.dispatch_tools) ||
        (!fspUser?.fsp_tier2 &&
            (isFF_FspAdmin ||
                ((isOrgFlightsAdmin ||
                    isFspAdmin ||
                    isFspFlightManager ||
                    isOrgDocumentsAdmin) &&
                    dispatch_tools)))
    )
        toReturn.push(renderDispatch);

    //Same as above for dispatch. If the user has fsp_tier2, the only rule that matters is if they have
    // flight_tracking_global or flight_tracking or not
    // doesnt matter what the managed user has.
    if (
        (!fspUser?.fsp_tier2 &&
            ((dispatch_tools && !hasDispatchLowca) || isFF_FspAdmin)) ||
        (fspUser?.fsp_tier2 && fspUser && hasTrackingLicense(fspUser))
    )
        toReturn.push(renderFleetTracking);

    if (isOrgAircraftAdmin && fspUser?.isFspAdmin)
        toReturn.push(renderAircraft);

    // FSP Tier 2 users should be able to manage custom content because of cc's integration with Dispatch
    if (fspUser?.fsp_tier2 && hasCustomContentMenuItem(currentUser)) {
        toReturn.push(renderCustomContent);
    }

    toReturn.push(renderAirportDirectory);

    if (isOrgUserAdmin && fspUser?.isFspAdmin) toReturn.push(renderOrg);

    if (isOrgDocumentsAdmin && fspUser?.isFspAdmin) toReturn.push(renderDocs);

    toReturn.push(fillSpace.bind(null, { flex: '1' }));
    return toReturn;
}
